import { ListOptions } from "../models/Master";

export const eligibilityFormInitialState = {
  lastName: "",
  firstName: "",
  dateOfBirth: null,
  subscriberId: "",
  healthPlan: null,
};

export const eligibilityDefaultState = {
  lastName: "",
  dob: "",
  policyId: "",
  payerId: "",
  payerName: "",
};

export const NO_RECORD_FOUND = "NO RECORD FOUND";

export const HealthPlanData = {
  label: "",
  value: "",
};

export enum PayerType {
  AmeriHealth_Caritas_Keystone = "AmeriHealth Caritas/Keystone",
  HCSC = "HCSC",
  Blue_Cross = "Independence Blue Cross",
  BCBS_TN = "BCBS TN",
  BCBS_MI = "BCBS Michigan"
}

export enum EligibilityStatus {
  STATUS_TRUE = "True",
  STATUS_FALSE = "false",
  STATUS_NULL = "null",
}
export const EligibilityStatusNull = null;
export interface EligibilityCheckData {
  lastName: string;
  dateOfBirth: string;
  healthPlan: string;
  subscriberId: string;
  policyId: string;
  payerName: string;
  dob: string;
}

export enum EligibilityInformationActionDispatchTypes {
  SET_ELIGIBILITY_INFORMATION_INVOKE = "SET_ELIGIBILITY_INFORMATION_INVOKE",
  SET_ELIGIBILITY_INFORMATION_SUCCESS = "SET_ELIGIBILITY_INFORMATION_SUCCESS",
}

export const getType = (data: ListOptions) => {
  switch (data.label) {
    case PayerType.HCSC:
      return 1;
    case PayerType.AmeriHealth_Caritas_Keystone:
      return 2;
    case PayerType.Blue_Cross:
      return 3;
    case PayerType.BCBS_TN:
      return 4;
    case PayerType.BCBS_MI:
      return 5;
    default:
      return 0;
  }
};
